import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText } from '@wordpress/block-editor';
import { useEffect } from '@wordpress/element';

import metadata from './block.json';
import Style from './Style';



export default function Edit( props ) {
	const { attributes, setAttributes, clientId } = props;
	const {
		blockID,
		buttonText,
		buttonIcon,
		iconPosition,
		enableIcon,
		buttonLinkUrl,
		buttonLinkOpenInNewTab,
		buttonLinkRel,
		buttonLinkTitle,
		buttonAnchorId,
	} = attributes;

	useEffect( () => {
		setAttributes( { blockID: clientId } );
	}, [ clientId ] );

	const blockProps = useBlockProps( {
		className: `block-${ blockID }`,
	} );

	const rel = [];
	if ( buttonLinkOpenInNewTab ) {
		rel.push( 'noopener', 'noreferrer' );
	}
	if ( buttonLinkRel ) {
		rel.push( buttonLinkRel );
	}
	const relString = rel.length > 0 ? rel.join( ' ' ) : null;

	const buttonClasses = [ 'alpha-button' ];

	return (
		<>
			<window.InspectorGenerator props={ props } blockJson={ metadata } />
			<Style
				attributes={ attributes }
				blockID={ blockID }
				setAttributes={ setAttributes }
			/>
			<div { ...blockProps }>
				<a
					href={ buttonLinkUrl }
					target={ buttonLinkOpenInNewTab ? '_blank' : null }
					rel={ relString }
					title={ buttonLinkTitle }
					id={ buttonAnchorId }
					className={ buttonClasses.join( ' ' ) }
					onClick={ ( e ) => e.preventDefault() }
				>
					<span
						style={ {
							display: 'flex',
							alignItems: 'center',
						} }
					>
						{ enableIcon &&
							buttonIcon?.iconName &&
							iconPosition === 'left' && (
								<window.Icon name={ buttonIcon.iconName } />
							) }
						<RichText
							tagName="span"
							value={ buttonText }
							onChange={ ( newText ) =>
								setAttributes( { buttonText: newText } )
							}
							placeholder={ __( 'Button Text', 'alpha-blocks' ) }
							allowedFormats={ [] }
						/>
						{ enableIcon &&
							buttonIcon?.iconName &&
							iconPosition === 'right' && (
								<window.Icon name={ buttonIcon.iconName } />
							) }
					</span>
				</a>
			</div>
		</>
	);
}
